import {
  GET_CIVILOPNAME,
  GET_CIVILOPNAME_SUCCESS,
  GET_CIVILOPNAME_FAIL,
  DELETE_CIVILOPNAME,
  DELETE_CIVILOPNAME_SUCCESS,
  DELETE_CIVILOPNAME_FAIL,
  UPDATE_CIVILOPNAME,
  UPDATE_CIVILOPNAME_SUCCESS,
  UPDATE_CIVILOPNAME_FAIL,
  ADD_NEW_CIVILOPNAME,
  ADD_CIVILOPNAME_SUCCESS,
  ADD_CIVILOPNAME_FAIL,
  CIVILOPNAME_LOADING,
  CIVILOPNAME_RESET
} from "./actionType";

export const resetCivilOpnameState = (actionType) => ({
  type: CIVILOPNAME_RESET,
  payload: { actionType },
});

export const getCivilOpnameSuccess = (actionType, data) => ({
  type: GET_CIVILOPNAME_SUCCESS,
  payload: { actionType, data },
});

export const getCivilOpnameFail = (actionType, error) => ({
  type: GET_CIVILOPNAME_FAIL,
  payload: { actionType, error },
});

export const getCivilOpname = data => ({
  type: GET_CIVILOPNAME,
  payload: data,
});

export const getCivilOpnameLoading = () => ({
  type: CIVILOPNAME_LOADING
});

export const deleteCivilOpname = data => ({
  type: DELETE_CIVILOPNAME,
  payload: data,
});

export const deleteCivilOpnameSuccess = data => ({
  type: DELETE_CIVILOPNAME_SUCCESS,
  payload: data,
});

export const deleteCivilOpnameFail = error => ({
  type: DELETE_CIVILOPNAME_FAIL,
  payload: error,
});

export const updateCivilOpname = data => ({
  type: UPDATE_CIVILOPNAME,
  payload: data,
});

export const updateCivilOpnameFail = error => ({
  type: UPDATE_CIVILOPNAME_FAIL,
  payload: error,
});

export const updateCivilOpnameSuccess = data => ({
  type: UPDATE_CIVILOPNAME_SUCCESS,
  payload: data,
});

export const addNewCivilOpname = data => ({
  type: ADD_NEW_CIVILOPNAME,
  payload: data,
});

export const addCivilOpnameSuccess = data => ({
  type: ADD_CIVILOPNAME_SUCCESS,
  payload: data,
});

export const addCivilOpnameFail = error => ({
  type: ADD_CIVILOPNAME_FAIL,
  payload: error,
});